export type state = 'LEAD' | 'PROSPECT' | 'OFFICIAL';

export const statesAsArray: state[] = ['LEAD', 'PROSPECT', 'OFFICIAL'];
